import React, { useEffect, useState } from 'react';
import { gql, useQuery } from "@apollo/client";
import { useAuth0 } from '@auth0/auth0-react';

const GET_PEDIDOS = gql`
  query getPedidos {
    getPedidos {
      _id
      estado
      fecha
      numeroPedido
      nombreCliente
      direccionCliente
      whatsappCliente
      notaPedido
      productos
    }
  }
`;

function CierreCaja() {
  const { loading, error, data } = useQuery(GET_PEDIDOS);
  const { user, isAuthenticated } = useAuth0();
  const [totalDelDia, setTotalDelDia] = useState(0);
  const [fechaSeleccionada, setFechaSeleccionada] = useState("2026-07-31"); // 👈 fecha por defecto

  // Obtener la fecha actual en GMT-5 como string 'YYYY-MM-DD'
  const obtenerFechaColombia = () => {
    const ahora = new Date();
    ahora.setHours(ahora.getHours() - 5);
    return ahora.toISOString().split('T')[0];
  };

  // Convertir fecha ISO a formato 'YYYY-MM-DD' ajustado a GMT-5
  const fechaPedidoGMT5 = (fechaISO) => {
    if (!fechaISO) return null;
    const fecha = new Date(fechaISO);
    fecha.setHours(fecha.getHours() - 5);
    return fecha.toISOString().split('T')[0];
  };

  // Calcular total de productos (agrega 200 si el código es '1')
  const calcularTotal = (productos) => {
    return productos.reduce((total, producto) => {
      let subtotal;
      if (producto.codigo === '1') {
        subtotal = producto.precio * producto.cantidad ;
      } else {
        subtotal = producto.precio * producto.cantidad;
      }
      return total + subtotal;
    }, 0);
  };

  // Calcular el total del día según la fecha seleccionada
  useEffect(() => {
    if (data && data.getPedidos) {
      const pedidosDelDia = data.getPedidos.filter(pedido => {
        const fechaAjustada = fechaPedidoGMT5(pedido.fecha);
        return fechaAjustada === fechaSeleccionada;
      });

      const total = pedidosDelDia.reduce((suma, pedido) => {
        return suma + calcularTotal(JSON.parse(pedido.productos));
      }, 0);

      setTotalDelDia(total);
    }
  }, [data, fechaSeleccionada]);

  if (loading) return <p>Cargando...</p>;
  if (error) return <p>Error: {error.message}</p>;

  const pedidosDelDia = data.getPedidos.filter(pedido => {
    const fechaAjustada = fechaPedidoGMT5(pedido.fecha);
    return fechaAjustada === fechaSeleccionada;
  });

  return (
    <div style={{ padding: "20px" }}>
      <h1>Cierre de Caja</h1>

      {/* Selector de fecha */}
      <div style={{ marginBottom: "20px" }}>
        <label>Selecciona una fecha: </label>
        <input
          type="date"
          value={fechaSeleccionada}
          max={obtenerFechaColombia()}
          onChange={(e) => setFechaSeleccionada(e.target.value)}
        />
      </div>

      <div className='card card-total'>
        <h2>Total ventas del {fechaSeleccionada}: ${totalDelDia.toLocaleString()}</h2>
      </div>

      {isAuthenticated && (
        <div>
          <h3>Usuario autenticado:</h3>
          <p><strong>{user.name}</strong> ({user.email})</p>
        </div>
      )}

      <h2>Pedidos del {fechaSeleccionada}</h2>
      {pedidosDelDia.length === 0 ? (
        <p>No hay pedidos para esta fecha.</p>
      ) : (
        pedidosDelDia.reverse().map((pedido) => (
          <div
            key={pedido._id}
            id={`pedido-${pedido._id}`}
            style={{
              border: "1px solid #ccc",
              borderRadius: "8px",
              padding: "15px",
              marginBottom: "15px"
            }}
          >
            <p>{pedido._id}</p>
            <p>{pedido.nombreCliente}</p>
            <p>{pedido.whatsappCliente}</p>
            <h3>Número de Pedido: {pedido.numeroPedido}</h3>
            <p><strong>Fecha:</strong> {pedido.fecha}</p>
            <p><strong>Estado:</strong> {pedido.estado}</p>
            <p><strong>Cliente:</strong> {pedido.nombreCliente}</p>
            <p><strong>Dirección:</strong> {pedido.direccionCliente}</p>
            <p><strong>WhatsApp:</strong> {pedido.whatsappCliente}</p>
            <p><strong>Nota:</strong> {pedido.notaPedido}</p>


            <h4>Productos:</h4>
            <ul>
              {pedido.productos &&
                JSON.parse(pedido.productos).map((producto) => (
                  <li key={producto.id}>
                  
                    {producto.nombre} - Precio: ${producto.precio} - Cantidad: {producto.cantidad}
                  </li>
                ))}
            </ul>
            <h4>
              Total del Pedido: ${calcularTotal(JSON.parse(pedido.productos)).toLocaleString()}
            </h4>
          </div>
        ))
      )}
    </div>
  );
}

export default CierreCaja;
